<!-- USERS -->
<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel">
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION -->
                <v-col :cols="computedCols">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                            <app-text category="content-title">{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text> 
                            <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.text`) }}</app-text>                                                
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS -->
                <v-col :cols="computedCols" class="px-2">
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="12" md="4" class="">
                            <v-text-field background-color="white" v-model="search" prepend-inner-icon="icons8-search" filled dense :label="$t(`filters.search`)" clearable hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.type" :items="userTypes" item-text="text" item-value="value" filled dense clearable :label="$t(`filters.type`)" hide-details>
                                <template v-slot:item="data">{{ data.item.text }}</template>
                                <template v-slot:selection="data">{{ data.item.text }}</template>                                 
                            </v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.roles" :items="userRoles" item-text="text" item-value="value" filled dense clearable :label="$t(`filters.roles`)" hide-details>
                                <template v-slot:item="data">{{ data.item.text }}</template>
                                <template v-slot:selection="data">{{ data.item.text }}</template>                                                                 
                            </v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-autocomplete :disabled="GET_currentUser.userType === 'CONTRACTOR'" :menu-props="{ top: false, offsetY: true }" :attach="true" autocomplete="donotautocomplete" background-color="white" v-model="filter.organisation" filled dense :label="$t('filters.organisation')" hide-details auto-select-first clearable :items="organisations" item-text="organisationName" return-object>
                                <!-- <template v-slot:item="data">
                                     {{ data.item.organisationName }} -->
                                    <!-- <span v-if="data.item.organisationStatus === 'PENDING'" class="warning--text font-weight-bold pl-1">(PENDING)</span> -->
                                    <!-- <span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.organisationType }}</span> -->
                                <!-- </template> -->
                                <!-- <template v-slot:selection="data">
                                     {{ data.item.organisationName }}
                                </template> -->
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.site" :items="sites" item-text="siteName" return-object filled dense clearable :label="$t(`filters.lastSite`)" hide-details>
                                <template v-slot:item="data">{{ data.item.siteName }}</template>
                                <template v-slot:selection="data">{{ data.item.siteName }}</template>                                 
                            </v-select>
                        </v-col>                        
                        <v-col cols="12" xs="12" sm="12" md="4" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="sortBy" :items="filteredHeaders" item-text="text" item-value="value" filled clearable dense :label="$t(`filters.sortBy`)" hide-details>
                                <template v-slot:item="data">{{ $t(`fields.${data.item.text}`) }}</template>
                                <template v-slot:selection="data">{{ $t(`fields.${data.item.text}`) }}</template>                                                    
                            </v-select>
                            <v-btn icon class="ml-2" @click="filter.sortAsc = !filter.sortAsc"><v-icon :class="{ 'icons8-down-arrow': filter.sortAsc, 'icons8-up-arrow': !filter.sortAsc }" class="text-h5"></v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            <!-- 
            <v-row class="ma-0 mt-2 pa-0" no-gutters>
                <v-col cols="2" class="py-2 pl-4">
                    <v-text-field background-color="white" prepend-inner-icon="icons8-search" filled dense :label="$t('filters.search')" v-model="search" clearable hide-details></v-text-field>
                </v-col>
                <v-col cols="2" class="pl-2 py-2">
                    <v-select background-color="white" filled dense clearable :label="$t('filters.workType')" hide-details></v-select>
                </v-col>
                <v-col cols="2" class="pl-2 py-2">
                    <v-autocomplete background-color="white" v-model="filter.organisation" filled dense :label="$t('filters.organisation')" hide-details auto-select-first clearable :items="organisations" item-text="organisationName" return-object></v-autocomplete>
                </v-col>      
                <v-col cols="2" class="pl-2 py-2">
                    <v-autocomplete background-color="white" v-model="filter.projectManager" filled dense :label="$t('filters.managedBy')" hide-details auto-select-first clearable :items="ownerManagers" item-text="userName" return-object></v-autocomplete>
                </v-col>         
                <v-col cols="2" class="pl-2 py-2">
                    <v-autocomplete background-color="white" v-model="filter.site" filled dense :label="$t('filters.site')" hide-details auto-select-first clearable :items="sites" item-text="siteName" return-object></v-autocomplete>
                </v-col>                                     
                <v-col cols="2" class="pl-2 pr-4 py-2">
                    <v-select background-color="white" v-model="sortBy" filled dense :label="$t('filters.sortBy')" hide-details :items="filteredHeaders">
                        <template v-slot:item="data">
                            <span>{{ $t(data.item.text) }}</span>
                        </template>
                        <template v-slot:selection="data">
                            <span>{{ $t(data.item.text) }}</span>
                        </template>                  
                    </v-select>
                </v-col> -->
                <!-- // * STATUS AND BUTTONS -->
                <v-col cols="12" class="pl-2 pr-0 d-flex align-center">
                    <!-- // * STATUS FILTER -->
                    <div>
                        <v-btn-toggle v-model="filter.status" multiple color="white" active-class="white" background-color="lightgrey" dense >
                          <v-btn value="APPROVED"><v-icon class="success--text icons8-checkmark-yes"></v-icon><span class="success--text caption hidden-sm-and-down"  >{{ $t(`status.approved`) }}</span></v-btn>
                          <v-btn value="REJECTED"><v-icon class="warning--text text--lighten-1 icons8-high-importance"></v-icon><span class="warning--text caption hidden-sm-and-down">{{ $t(`status.rejected`) }}</span></v-btn>
                          <v-btn value="PENDING"><v-icon class="grey--text text--lighten-1 icons8-circle"></v-icon><span class="grey--text caption hidden-sm-and-down">{{ $t(`status.pending`) }}</span></v-btn>
                          <v-btn value="SUSPENDED"><v-icon class="error--text text--lighten-1  icons8-private"></v-icon><span class="error--text caption hidden-sm-and-down">{{ $t(`status.suspended`) }}</span></v-btn>
                        </v-btn-toggle>
                    </div>
                    <!-- // * SHOW DELETED -->
                    <div class="d-flex" v-if="$vuetify.breakpoint.mdAndUp">
                        <v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon>
                        <v-switch @change="getTableData()" v-model="showDeleted" class="ml-1 purple--text" inset color="purple"></v-switch>                                            
                    </div>
                    <v-spacer></v-spacer>
                    <!-- // * BUTTONS -->
                    <div><appbutton v-if="selectedUsers.length > 0" label="Unselect All" icon="icons8-checkmark-yes" type="white" iconclass="secondary--text" labelclass="secondary--text" showlabel="xlOnly" @click.native="unselectAllUsers" /></div>
                    <div><appbutton v-if="selectedUsers.length !== computedTableData.length" class="mr-1" label="Select All" icon="icons8-checkmark-yes" type="secondary" iconclass="white--text" labelclass="white--text" 
                        @click.native="
                            selectAllUsers
                        " /></div>
                    <div><appbutton v-if="selectedUsers.length > 0" label="Print" class="mr-1" icon="icons8-name-tag" type="white" iconclass="secondary--text" labelclass="secondary--text" @click.native="qrDialog = !qrDialog" /></div>
                    <!-- <div v-if="$vuetify.breakpoint.mdAndUp"><appbutton :label="$t(`buttons.columns`)" icon="icons8-select-column" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="columnsDialog = true" /></div>
                    <div v-if="$vuetify.breakpoint.mdAndUp"><appbutton :label="$t(`buttons.export`)" class="mr-1" icon="icons8-export-csv" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="mix_exportDocuments(headersCSV,'Users',formatExport)" /></div> -->
                </v-col>
                <!-- // * TABLE -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        hide-default-header
                        :search="search"
                        >
                        <!-- // HEADERS -->                        
                        <template v-slot:header="{ props }">
                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                {{ $t(`fields.${head.text}`) }}
                            </th>
                        </template>     
                        <!-- // SELECTED -->             
                        <template v-slot:[`item.selected`]="{ item }">
                            <div class="d-flex align-center justify-center">
                                <v-checkbox
                                    class="mr-0"
                                    v-model="item.selected"
                                    @click="checkSelected"
                                    ></v-checkbox>
                            </div>
                        </template>
                        <!-- // STATUS -->             
                        <template v-slot:[`item.userStatus`]="{ item }">
                            <v-icon v-if="item.userStatus === 'APPROVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                            <v-icon v-if="item.userStatus === 'REJECTED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-high-importance"></v-icon>
                            <v-icon v-if="item.userStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                            <v-icon v-if="item.userStatus === 'SUSPENDED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 error--text icons8-private"></v-icon>
                        </template>
                        <!-- // NAME -->
                        <template v-slot:[`item.userName`]="{ item }">
                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="error--text d-inline-block text-truncate" style="max-width: 200px;"><v-icon class="error--text">icons8-trash</v-icon> {{ item.userName}}</span>
                            <span v-else class="d-inline-block text-truncate text-capitalize" style="max-width: 200px;">{{ item.userName }}</span>
                        </template>
                        <!-- // EMAIL WITH LINK -->
                        <template v-slot:[`item.userEmail`]="{ item }">
                            <span class="d-inline-block text-truncate" style="max-width: 200px;"><a class="grey--text text--darken-4 text-decoration-none" :href="'mailto:'+item.userEmail">  <v-icon>icons8-new-post</v-icon>      {{ item.userEmail }}</a></span>
                        </template>                        
                        <!-- // ORGANISATION -->
                        <template v-slot:[`item.organisation`]="{ item }">
                            <span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.organisation.organisationName }}</span>
                            <span class="d-inline-block text-truncate pl-2" style="max-width: 200px;" v-if="item.site !== '' && item.site !== null && item.site !== undefined">
                                <span v-if="item.site.siteId !== '' && item.site.siteId !== null && item.site.siteId !== undefined && item.organisation.organisationId === 'UshqEqj4OeCGI4JHMjUk'"> ({{ item.site.siteName }})</span>
                            </span>
                        </template>
                        <!-- // SPONSOR -->
                        <template v-slot:[`item.sponsor`]="{ item }">
                            <div v-if="item.sponsor.userName  !== '' && item.sponsor.userName  !== undefined && item.sponsor.userName  !== null" @click="MIX_popupUser(item.sponsor.userId)" class="pointer noselect fixedcolumn">
                                <v-icon>icons8-identification-documents</v-icon>      
                                {{ item.sponsor.userName }}
                            </div>
                        </template>
                        <!-- // InductionDate -->
                        <template v-slot:[`item.inductionStatus`]="{ item }">
                            <span v-if="item.inductionStatus === 'REQUIRED'" class="error--text font-weight-bold">Required</span>
                            <span v-if="item.inductionStatus === 'VALID'" class="success--text font-weight-bold">Valid</span>
                            <span v-if="item.inductionStatus === 'EXPIRED'" class="error--text font-weight-bold">Expired</span>
                            <span v-if="item.inductionStatus === 'DUE'" class="warning--text font-weight-bold">Due</span>
                        </template>      
                        <!-- // SWAPP STATUS-->
                        <template v-slot:[`item.swappStatus`]="{ item }">
                            <v-chip  class="success" small v-if="item.swappStatus === 1">IN</v-chip>
                            <v-chip  class="lightgrey" small v-else>OUT</v-chip>
                        </template>  
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col cols="12" xs="12" class="my-1 pa-1 white tablecard" v-for="item in computedTableData" :key="item.id" @click="openItem(item.id, 'View', false)">
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters >
                                <v-col cols="2" class="">
                                    <v-icon v-if="item.userStatus === 'APPROVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                    <v-icon v-if="item.userStatus === 'REJECTED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-high-importance"></v-icon>
                                    <v-icon v-if="item.userStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                    <v-icon v-if="item.userStatus === 'SUSPENDED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 error--text icons8-private"></v-icon>                                    
                                </v-col>
                                <v-col cols="7" class="d-flex flex-column">
                                    <div style="margin: 0px !important; line-height: 20px !important;" class="noselect"><span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.userName }}</span></div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ item.userType }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right"><v-icon @click="openItem(item.id, 'View', false)" depressed class="black--text white">mdi-chevron-right</v-icon></v-col>
                            </v-row>
                         </v-col>
                    </v-row>
                </v-col>
                <!-- // * COPYRIGHT -->
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                    <appcopyright  />
                </v-col>                
            </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
            mode="out-in">
            <rightpanel></rightpanel>
        </transition>
        <!-- // * DYNAMIC COMPONENT DIALOG -->        
        <v-dialog v-model="columnsDialog" scrollable max-width="300px">
            <v-card>
                <v-card-title>{{$t('miscHeadings.showHideColumns')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">
                    <v-list>
                        <v-list-item v-for="(header, index) in columnHeaders" :key="index">
                          <v-list-item-title><v-checkbox color="grey darken-1" hide-details v-model="headers[index].hidden" :false-value="true" :true-value="false" :label="$t(`fields.${header.text}`)"></v-checkbox></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer />
                    <v-btn color="primary" text @click="columnsDialog = false">Close</v-btn>
                </v-card-actions>            </v-card>
        </v-dialog>

        <v-dialog v-model="qrDialog" transition="dialog-bottom-transmission" max-width="1200" style="height: 800px !important">
            <v-card class="grey lighten-2">
                <v-toolbar color="primary" elevation=0>
                    <app-text category="text-medium" class="white--text ml-4">Print QR Card?</app-text>
                    <v-spacer />
                    <v-btn @click="qrDialog = false" icon dark>
                        <v-icon class="icons8-multiply pr-2" color="white" />
                    </v-btn>
                </v-toolbar>

                <div v-for="form in selectedUsers" :key="form.id">
                    <div id="qrCode" class="pa-4 d-flex align-center justify-center bg-grey" style="overflow: none !important">
                        <QRCard :user="form" />
                    </div>
                </div>

                <v-card-actions class="secondary justify-end mt-0 pa-4">
                    <!-- ENTER-ACCESS-CODE-BUTTON-->
                    <v-btn class="white" large @click="printQR">Print</v-btn>
                </v-card-actions>
                
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import QRCard from '@/components/QRCard.vue';
    import * as htmlToImage from "html-to-image";
    import * as html2canvas from "html2canvas";
    import { mapActions, mapGetters } from 'vuex'; // Map Actions / Getters
    export default {
        components: {
            QRCard
        },
        // * DATA
        data: () => ({
            collection: 'users',
            collectionTitle: 'Users',
            collectionItem: 'user',
            collectionItemTitle: 'User',  
            langPath: 'bulk',
            columnsDialog: false,
            search: '', // Table Search
            sortBy: 'userName', // Default Table Sort By
            customWhere: [],
            filter: {
                // Default Filters
                sortAsc: true,
                status: ['APPROVED', 'PENDING', 'REJECTED', 'SUSPENDED'],
                type: '',
                roles: '',
                organisation: null,
                site: ''
            },
            tableData: [], // Table Data
            headers: [ // Table Headers
                // hidden shows the initial value of the column - hidden or visible
                // hides determines if you want to hide the column on screen resize
                { text: 'selected', value: 'selected', sortable: false, align: 'center', hidden: false, hide: false },
                { text: 'status', value: 'userStatus', sortable: false, align: 'center', hidden: false, hide: false },
                { text: 'id', value: 'id', sortable: false, align: 'start', hidden: true, hide: false },
                { text: 'name',  value: 'userName', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'jobTitle', value: 'userJobTitle', sortable: false, align: 'start', hidden: false, hide: true },
                { text: 'organisation', value: 'organisation', sortable: false, align: 'start', hidden: false, hide: false },

                { text: 'email', value: 'userEmail', sortable: false, align: 'start', hidden: false, hide: false },
                { text: 'telephone', value: 'userTelephone', sortable: false, align: 'start', hidden: false, hide: true },
                // { text: 'subContractorName', value: 'subContractorName', sortable: false, align: 'start', hidden: false, hide: false },
                { text: 'sponsor',  value: 'sponsor', sortable: false, align: 'start', hidden: false, hide: false },
                { text: 'userType', value: 'userType', sortable: false, align: 'start', hidden: true, hide: false },
                { text: 'userRole', value: 'userRole', sortable: false, align: 'start', hidden: true, hide: false },
                { text: 'swappStatus', value: 'swappStatus', sortable: false, align: 'center', hidden: false, hide: true },                
                { text: 'lastSite', value: 'lastSite', sortable: false, align: 'start', hidden: true, hide: true },
                { text: 'lastLocation', value: 'lastLocation', sortable: false, align: 'start', hidden: true, hide: true },
                { text: 'description', value: 'description', sortable: false, align: 'start', hidden: true, hide: false },
                { text: 'inductionStatus', value: 'inductionStatus', sortable: false, align: 'start', hidden: false, hide: true },
                { text: 'created', value: 'createdDateTime', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
                { text: 'createdUserData', value: 'createdUserData', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
                { text: 'modified', value: 'modifiedDateTime', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
                { text: 'modifiedUserData', value: 'modifiedUserData', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
                { text: 'delete', value: 'delete', align: 'left', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', sortable: false, align: 'start', align: 'start', hidden: true, hide: false },                
                { text: 'actions', value: 'actions', align: 'right', sortable: false, sortable: false, hidden: false,  hide: false },
            ],
            headersCSV: {
                userStatus: 'Status',
                id: 'ID',
                userName: 'Name',
                userEmail: 'Email',
                userTelephone: 'Telephone',
                organisation: 'Organisation',
                userType: 'Type',
                userRole: 'Role',
                userJobTitle: 'Job Title',
                swappStatus: 'SWAPP Status',
                lastSite: 'Last Site',
                lastLocation: 'Last Location',
                createdDateTime: 'Created Date and Time',
                createdUserData: 'Created By',
                modifiedDateTime: 'Modified Date and Time',
                modifiedUserData: 'Modified By',
            },
            // EXPORT
            exportData: [],
            // LOOKUP VALUES
            userTypes: [], // USER TYPES
            userRoles: [], // USER ROLES
            contactTypes: [], // CONTACT TYPES
            sites: [], // SITES
            organisations: [], // ORGANISATIONS
            showDeleted: false, // SHOW DELETED
            filteredHeaders: [],


            // * QR DIALOG
            qrDialog: false,
            selectedUsers: [],

        }),      
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_panelLayout: 'GET_panelLayout',
                GET_lookupValues: 'GET_lookupValues',      
                GET_help: 'GET_help',
                GET_organisations: 'GET_organisations',
                GET_sites: 'GET_sites'                                          
            }),
            formatExport() {
                this.exportData = JSON.parse(JSON.stringify(this.computedTableData))
                return this.exportData
            },
            // Computed Table Headers            
            // computedHeaders() {
            //     var t = this;
            //     var headers = t.headers;
            //     return (t.$filter(headers, {
            //         hidden: false, // filter headers based on initial hidden value
            //     }));
            // },
            // Remove actions from Selectable Column Headers
            columnHeaders() {
                var t = this;
                var headers = t.headers;
                return (headers.filter((header) => {
                    return header.value !== 'actions'
                }));
            },
            // Computed Cols
            computedCols() {
                var t = this;
                var cols
                var leftPanel = t.GET_panelLayout.leftPanel
                switch (true) {
                    case (leftPanel === 12): cols = 6; break
                    case (leftPanel === 6): cols = 12; break;
                    default: cols = 12;
                }
                if (t.$vuetify.breakpoint.smAndDown) { cols = 12 }
                return cols
            },
            // Computed Table Data
            computedTableData() {
                var t = this;
                var tableData = t.tableData;

                // Filter by status
                tableData = tableData.filter(function(item) {
                    return t.filter.status.includes(item[t.collectionItem+'Status']);
                });
                // Filter by type
                if ((t.filter.type !== '') && (t.filter.type !== undefined) && (t.filter.type !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.type === item[t.collectionItem + 'Type'];
                    });
                }
                // Filter by Roles
                if ((t.filter.roles !== '') && (t.filter.roles !== undefined) && (t.filter.roles !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.roles === item[t.collectionItem + 'Role'];
                    });
                }
                // Filter by Search Mobile                
                if (t.search !== '' && t.$vuetify.breakpoint.smAndDown) {
                    tableData = tableData.filter(function(item) {
                        var itemName = item[t.collectionItem+'Name'].toUpperCase();
                        var search = t.search.toUpperCase();
                        return itemName.includes(search)
                    });
                }
                // Filter by Organisation (CUSTOM)
                if ((t.filter.organisation !== '') && (t.filter.organisation !== undefined) && (t.filter.organisation !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.organisation.organisationId === item.organisation.organisationId;
                    });
                }                             
                // Filter by Site                
                if ((t.filter.site !== '') && (t.filter.site !== undefined) && (t.filter.site !== null)) {                    
                    tableData = tableData.filter(function(item) {
                        return t.filter.site.siteId === item.lastSite.siteId;
                    });
                }                              
                var tableDataList = tableData.map(e => {
                    return {
                        userStatus: e.userStatus,
                        id: e.id,
                        selected: e.selected,
                        userName: e.userName,
                        userJobTitle: e.userJobTitle,
                        organisation: e.organisation,
                        userEmail: e.userEmail,
                        userTelephone: e.userTelephone,
                        sponsor: e.host,                
                        site: e.site,    
                        inductionStatus: this.calculateInduction(e.inductionDate), 
                        userType: e.userType,
                        userRole: e.userRole,
                        lastSite: e.lastSite.siteName,
                        subContractorName: e.subContractorName,
                        lastLocation: e.lastLocation.locationName,
                        swappStatus: e.swappStatus,
                        // createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        // createdUserData: e.createdUserData,
                        // modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        // modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                // Sort the Table by the Field in the Sort By Filter
                var sortResults = t.$sortBy(tableDataList, t.sortBy)
                if (!t.filter.sortAsc) {sortResults.reverse()}
                return (sortResults);      
            }
        },
        // * WATCH
        watch: {
            GET_currentUser: {
                handler() {
                    this.getTableData();
                }, deep: true
            },
            GET_panelLayout: {
                handler() {
                    let t = this;
                    if (t.GET_panelLayout.rightPanel === 6) {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hide === false && header.hidden === false);
                        });
                    } else {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hidden === false);
                        }) 
                    }
                }, deep: true,
            },
            headers: {
                handler() {
                    let t = this;
                     t.filteredHeaders = t.headers.filter((header) => {
                         return (header.hidden === false)
                     });
                }, deep: true,
            }
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openUser'}),            
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                t.MIX_breadcrumbs(breadcrumbs);
            },
            unselectAllUsers() {
                var t = this;
                for (var i = 0; i < t.computedTableData.length; i++) {
                    t.computedTableData[i].selected = false;
                }
                t.selectedUsers = [];
                return;
            },
            selectAllUsers() {
                var t = this;
                for (var i = 0; i < t.computedTableData.length; i++) {
                    t.computedTableData[i].selected = true;
                }

                console.log('computing selected  = ' + t.computedTableData.length)
                var selected = t.computedTableData.filter(function(item) {
                    return item.selected === true;
                });
                console.log('selected = ' + selected.length)
                t.selectedUsers = selected;
                return selected;
            },
            checkSelected() {
                var t = this;
                console.log('computing selected  = ' + t.computedTableData.length)
                var selected = t.computedTableData.filter(function(item) {
                    return item.selected === true;
                });
                console.log('selected = ' + selected.length)
                t.selectedUsers = selected;
                return selected;
            },
            // download(url) {
            //     var a = $("<a style='display:none' id='js-downloder'>")
            //         .attr("href", url)
            //         .attr("download", "test.png")
            //         .appendTo("body");

            //     a[0].click();

            //     a.remove();
            // },
            async downloadImage(element, i) {
                var t = this;
                // Capture the card rather than its #qrCode wrapper, so the PNG is exactly card sized and fills the card when printed
                // pixelRatio must stay 1: html-to-image 1.3.20 enlarges the canvas by it without scaling the card, leaving the card in the top left corner
                await htmlToImage.toBlob(element.querySelector('.v-card'), { pixelRatio: 1 }).then(async function(canvas) {
                    // get user details based on i
                    var user = t.selectedUsers[i];
                    window.saveAs(canvas, user.userName + ".png");
                    // t.download(canvas.toDataURL("image/png"));
                //     return
                })
                .catch(function(error) {
                    console.error('oops, something went wrong!', error);
                });
            },
            async printQR() {
                var t = this;
                var elements = document.querySelectorAll('#qrCode');
                console.log('elements.lnegth = ' + JSON.stringify(elements.length, null, 2))

                for (var i = 0; i < elements.length; i++) {
                    await t.downloadImage(elements[i], i)
                }

            },
            // OPEN ITEM
            openItem: async function(id, process, popup) {
                var t = this;
                var item = {}                
                t.dynamicComponentKey++; 
                item.process = process;
                item.popup = popup;
                if (item.process !== 'New') {
                    var itemResult = await t.MIX_readDocumentById(t.collection, id)
                    item.data = itemResult.data;
                } else {
                    item.data = null;
                }
                t.ACT_openItem(item); // Open Item
                if (t.$vuetify.breakpoint.lgAndDown) {
                    t.MIX_fsDialog(true, t.collectionItemTitle, t.collectionItem);
                    t.MIX_setPanelLayout(12, 0, false, '');
                } else {
                    t.MIX_setPanelLayout(6, 6, true, t.collectionItemTitle, t.collectionItem);
                    // // * HIDE HEADERS
                    // for (var i = 0; i < t.headers.length; i++) {
                    //     if (t.headers[i].hide === true) {
                    //         t.headers[i].hidden = true;
                    //     }
                    // }
                }
                return;
            },
            // REMOVE UPLOADED DOCUMENT
            removeUploadedDocument(){
                this.$store.commit("upload_file_store/setFile", null); 
            },
            // GET NOTICES SNAPSHOT METHOD
            getTableData: async function () {
                var t = this;
                var collection = t.$firebase.db.collection(t.collection)
                t.customWhere = [];
                switch (true) {
                    case (t.GET_currentUser.userType === 'CONTRACTOR' || t.GET_currentUser.userType === 'VISITOR'):
                        t.customWhere.push ({ key: 'organisation.organisationId', operator: '==', value: t.GET_currentUser.organisation.organisationId });
                        break;
                    default: 

                }

                if (JSON.stringify(t.customWhere) !== '[]') {
                    for (var i = 0; i < t.customWhere.length; i++) {
                        var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                        collection = collection.where(query.field, query.operator, query.value)   
                    }
                }
                collection.onSnapshot(function(querySnapshot) {
                    t.tableData = [];
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id;
                        document.selected = false;
                        if (!document.hasOwnProperty('delete')) {
                            t.tableData.push(document);
                        } else if (t.showDeleted) {
                            t.tableData.push(document);
                        } else {
                            // Do not Show Concern
                        }
                    });
                });
                return;
            },
            calculateInduction: function(date) {
                let t = this;
                var inductionStatus
				if (date !== '') {
                    var inductionDate2Y = t
						.$moment(date, "x")
						.add(2, "years")
						.format("x");
					var currentDate = t.$moment().format("x");
					var inductionDue = t.$moment(currentDate, "x").diff(t.$moment(inductionDate2Y, "x"), "days");
					//var inductionRenewal = inductionDate2Y;
					switch (true) {
						case inductionDue > 0:
							inductionStatus = "EXPIRED";
							break;
						case inductionDue > -90 && inductionDue < 0:
							inductionStatus = "DUE";
							break;
						default:
							inductionStatus = "VALID";
							break;
					}
				} else {
					inductionStatus = "REQUIRED";
                    //console.log('inductionStatus = ' + t.inductionStatus)
				}
                return inductionStatus
            },
        },
        // * MOUNTED
        async mounted() {
            // * DEFAULT MOUNTED
            var t = this;
            t.MIX_setPanelLayout(12, 0, false, ''); // Hide Right Panel
            t.updateBreadcrumbs(); // Update Breadcrumbs in Title
            // INSERT CUSTOM WHERES HERE
            // t.customWhere.push ({ key: '', operator: '==', value: '' });
            t.getTableData(); // Get Table Data            
            // * LOOKUP RELATED MOUNTED
            // LOOKUPS
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.userTypes = await t.GET_lookupValues('USERTYPES');
            t.userRoles = await t.GET_lookupValues('USERROLES');
            t.contactTypes = await t.GET_lookupValues('CONTACTTYPES');
            // GET SITES
            await t.MIX_sites(); // UPDATE SITES LIST IN STORE (id, siteName)
            t.sites = t.$sortBy(t.GET_sites, 'siteName');; // STORE SITES IN LOCAL ARRAY
            // GET ORGANISATIONS
            await t.MIX_organisations(); // UPDATE SITES LIST IN STORE (id, siteName)
            t.organisations = t.$sortBy(t.GET_organisations, 'organisationName'); // STORE SITES IN LOCAL ARRAY
         
        },
    }; 
</script>

<style>
    /* .border-bottom-red { background-color: white; border-bottom: 2px solid var(--v-primary-base) !important; }
    .bottom { position: fixed; bottom: 30px; } */
</style>
